import React from "react";

import AOS from "aos";
import "aos/dist/aos.css";

function Community() {
  return (
    <div className="container mx-auto">
      {/* <div className="flex flex-col gap-20 px-4 py-20 bg-gray-200 mt-72"> */}
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center justify-center">
          <div className="flex text-3xl font-semibold">
            {/* <p className="text-main">코끼리협동조합</p> */}
            <p className="text-gray-800">뉴스레터</p>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Community;
